module.exports = __webpack_public_path__ + "static/media/eirich-mixer-home-s.7bd896cd.jpg";